import React, { useState, useEffect } from "react";

function ResetPasswordModal({ open, user, onClose, onSubmit }) {
  const [form, setForm] = useState({ newPassword: "", confirmPassword: "" });
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (open) {
      setForm({ newPassword: "", confirmPassword: "" });
      setMessage("");
    }
  }, [open]);

  if (!open || !user) return null;

  const handleSubmit = async () => {
    if (form.newPassword !== form.confirmPassword) {
      setMessage("兩次密碼不一致");
      return;
    }

    try {
      await onSubmit(user.userId, form.newPassword);
      setMessage("密碼重設成功");
      alert("密碼重設成功");
      setTimeout(() => onClose(), 1000);
    } catch (err) {
      setMessage("重設失敗：" + (err.response?.data?.message || "請稍後再試"));
      alert("重設失敗：" + (err.response?.data?.message || "請稍後再試"));
    }
  };

  return (
    <>
      <div className="modal show fade d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">重設密碼 - {user.name}</h5>
              <button className="btn-close" onClick={onClose}></button>
            </div>
            <div className="modal-body">
              <input
                type="password"
                className="form-control mb-2"
                placeholder="新密碼"
                value={form.newPassword}
                onChange={(e) => setForm({ ...form, newPassword: e.target.value })}
              />
              <input
                type="password"
                className="form-control mb-2"
                placeholder="再次輸入新密碼"
                value={form.confirmPassword}
                onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
              />
              {message && <div className="alert alert-info">{message}</div>}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={onClose}>
                取消
              </button>
              <button className="btn btn-primary" onClick={handleSubmit}>
                送出
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default ResetPasswordModal;
